<template>
  <div class="wrap">
    <header class="toubuyi">
      <div class="logo">
        <!-- <img :src="`${baseUrl}/common/index/getUserLogo?key=${host}`" class="logo-img" /> -->
        <img :src="webInfo.web_header_logo || defaultHeader" class="logo-img" />
      </div>
      <ul class="toubuwz" id="list">
        <router-link to="/">
          <li style="margin-left: 38px" :class="curPage === 'index' ? 'current' : ''">首页</li>
        </router-link>
        <router-link to="/myClass">
          <li style="margin-left: 38px" :class="curPage === 'MyClass' ? 'current' : ''">我的课程</li>
        </router-link>
        <router-link to="/vipcourse">
          <li style="margin-left: 38px" :class="curPage === 'VipCourse' ? 'current' : ''">1V1约课</li>
        </router-link>
      </ul>
      <!-- <input class="shuru" placeholder="搜索课程关键词" type="text" />
      <img style="float: left; margin-top: 24px; margin-left: -35px" src="./images/sousuo.png" alt="" /> -->
      <!-- 登录前 -->
      <div :sendData="newStudy" v-if="!isLogin" class="before-login">
        <button class="denglu" @click="open1()">登录</button>
        <button class="zhuce" @click="open2()">免费注册</button>
      </div>
      <!-- 登录后 -->
      <div v-if="isLogin" class="course">
        <!-- <router-link :to="{ path: '/zhanghu', query: { setid: 123123 } }" >个人中心</router-link> -->
        <!-- <div class="out-login" @click="handleOutLogin">退出登录</div> -->
        <!-- <div class="head-sculpture" :style="{ backgroundImage: 'url(' + headSculpture + ')' }"></div> -->
        <div class="nickName">{{nick_name}}</div>
        <el-badge :value="unreadCount" v-if="showBadge&&unreadCount!=0">
        <el-popover
          placement="top-end"
          width="50"
          padding="0"
          trigger="hover"
          visible-arrow="false"
          popper-class="popoverClass"
          >
          <div class="head-sculpture" :style="{ backgroundImage: 'url(' + headSculpture + ')' }"  slot="reference"></div>
          <div class="popover-box">
            <div class="content_box">
              <img src="./images/information.png" alt="">
              <img src="./images/information-active.png" alt="">
                <router-link :to="{ path: '/zhanghu', query: { setid: 123123 } }" class="tolink">个人中心</router-link>
            </div>
            <div class="content_box">
              <img src="./images/loginOut.png" alt="">
              <img src="./images/loginOut-active.png" alt="">
              <span @click="handleOutLogin" class="tolink">退出登录</span>
            </div>
          </div>
        </el-popover>
        </el-badge>
        <el-popover
          v-else
          placement="top-end"
          width="50"
          padding="0"
          trigger="hover"
          visible-arrow="false"
          popper-class="popoverClass"
          >
          <div class="head-sculpture" :style="{ backgroundImage: 'url(' + headSculpture + ')' }"  slot="reference"></div>
          <div class="popover-box">
            <div class="content_box">
              <img src="./images/information.png" alt="">
              <img src="./images/information-active.png" alt="">
                <router-link :to="{ path: '/zhanghu', query: { setid: 123123 } }" class="tolink">个人中心</router-link>
            </div>
            <div class="content_box">
              <img src="./images/loginOut.png" alt="">
              <img src="./images/loginOut-active.png" alt="">
              <span @click="handleOutLogin" class="tolink">退出登录</span>
            </div>
          </div>
        </el-popover>
      </div>
    </header>
    <Login ref="loginH" @updateLoginState="changeLoginState" />
  </div>
</template>

<script>
import Login from './login'
import { mapGetters } from 'vuex'

export default {
  components: {
    Login,
  },
  data() {
    return {
      headSculpture: require('./images/ico_zhanghao@2x.png'),
      newStudy: true,
      loginStudy: false,
      nick_name: '',
      icon: '',
      curPage: '',
      isLogin: false,
      token: '',
      host: '',
      baseUrl: process.env.VUE_APP_API_ONLINE_SCHOOL,
      checkToken:null,
      defaultHeader: '',
      unreadCount: 0,
      showBadge:true,
    }
  },
  computed: {
    ...mapGetters({
      webInfo: 'getWebInfo'
    })
  },
  created() {
    this.host = location.host
  },
  mounted() {
    // 获取当前页面名称
    this.curPage = this.$route.name
    // 是否登录状态
    this.checkIsLogin()
    const currentRoutePath = this.$route.path
    console.log('[<-- currentRoutePath -->]',currentRoutePath);
    if (currentRoutePath=='/zhanghu') {
      this.showBadge=false
    }
  },
  beforeDestroy(){
    clearInterval(this.checkToken)
  },
  methods: {
    getCourseHomeworkRead(){
      this.$tenghuiApi.post('/onlineapi/user/index/getCourseRead').then(res=>{
        console.log('[<-- res作业未读数 -->]',res);
        if (res.data.code==200) {
          this.unreadCount=res.data.data
        }    
      })
      
    },
    open1() {
      this.$refs.loginH.open()
    },
    open2() {
      this.$refs.loginH.open()
      this.$refs.loginH.v_zhuce()
    },
    changeLoginState() {
      this.isLogin = true
      this.$emit('gettoken',this.isLogin)
      this.getUserInfo()
      clearInterval(this.checkToken)
      this.checkToken = setInterval(() => {
        console.log('登录状态222')
        this.checkTokenValid()
      }, 10000)
    },
    // 获取用户信息
    getUserInfo() {
      this.$axios.post('/user/index/getUserInfo').then((res) => {
        if (res.data.code === 200) {
          localStorage.setItem('tengface_fans_id', res.data.data.id)
          this.nick_name = res.data.data.nick_name
          this.headSculpture = res.data.data.icon
          if (res.data.data.org_id) {
            localStorage.setItem('tengface_org_id', res.data.data.org_id)
            this.$store.commit('user/setOrgID',res.data.data.org_id)
          }
          console.log('[<-- res.data.data.stu_note -->]',res.data.data.stu_note);
          this.$store.commit('user/setRemark',res.data.data.stu_note)
          this.$store.commit('user/setFansId',res.data.data.id)
        } 
      })
    },
    // 检查是否为登陆状态
    checkIsLogin() {
      const token = localStorage.getItem('token')
      this.token = token
      if (token) {
        this.isLogin = true
        this.getCourseHomeworkRead()
        this.getUserInfo()
        clearInterval(this.checkToken)
        this.checkToken = setInterval(() => {
          this.checkTokenValid()
        }, 10000)
      }
    },
    checkTokenValid() {
      this.$axios.post('/user/index/checkToken').then((res) => {
          if (res.data.code === 100068 || res.data.code === 100067) {
            this.$message({
              message: 'token失效重新登录',
              type: 'error',
            })
            setTimeout(() => {
              this.handleOutLogin()
            }, 1000)
          } else if(res.data.code == 10000) {
            this.$confirm('该机构已被禁用，直播相关功能限制使用', '提示', {
              showClose: false,
              showConfirmButton: false,
              showCancelButton: false,
              closeOnClickModal: false,
              type: 'error'
            })
          }
      })
    },
    // 退出登陆
    handleOutLogin() {
      localStorage.removeItem('token')
      location.reload()
    },
  },
}
</script>

<style scoped>

.nickName{
  line-height: 40px;
  margin-right: 16px;
font-size: 14px;
}
* {
  margin: 0;
  padding: 0;
}
p {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
  color: #434343;
}
/* 头部 */
.logo {
  z-index: 9;
  display: flex;
  height: 64px;
  align-items: center;
}
.item {
  margin-top: 10px;
  margin-right: 40px;
}
.logo-text {
  color: #202020;
}
.logo-img {
  height: 50px;
}
.logo-text-title {
  font-size: 22px;
  font-family: MicrosoftYaHei;
  font-weight: 900;
}
.logo-text-desc {
  font-size: 10px;
}
.toubu {
  width: 100%;
  height: 64px;
  opacity: 1;
  background: #fff;
  box-shadow: 0px 1px 0px 0px #e8eaec;
  z-index: 9;
}
.toubuyi {
  width: 1280px;
  height: 64px;
  margin: 0 auto;
  position: relative;
  /* padding-left: calc(100vw - 100%); */
  /* background: #f5f5f5; */
}
.logo {
  opacity: 1;
  font-size: 20px;
  font-family: DINPro, DINPro-Black;

  text-align: left;
  color: #10a675;
  float: left;
}

.toubuwz li:hover {
  color: #1872ED;
}
.toubuwz li {
  list-style-type: none;
  width: 88px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  float: left;
  margin-left: 5px;
  font-size: 16px;
  color: #202020;
  text-decoration: none;
}
#list .current {
  color: #1872ED;
  position: relative;
}
#list .current::after{
  content: '';
  width: 33px;
  height: 4px;
  background-color: #1872ed;
  border-radius: 2px;
  position: absolute;
  bottom: 10px;
  left:50%;
  transform: translate(-50%);
  }
.shuru {
  width: 260px;
  height: 36px;
  opacity: 1;
  background: #ffffff;
  border: 1px solid #10a675;
  border-radius: 19px;
  margin-top: 14px;
  margin-left: 100px;
  float: left;
  padding-left: 18px;
}
input:focus {
  outline: none;
}
.denglu {
  padding: 7px 25px;
  opacity: 1;
  font-size: 14px;
  border-radius: 18px;
  margin-top: 14px;
  border: none;
  background-color: #fff;
  color: #1872ed;
  margin-left: 200px;
  cursor: pointer;
}
.zhuce {
  padding: 7px 23px;
  opacity: 1;
  font-size: 14px;
  border-radius: 18px;
  border: none;
  background-color: #1872ed;
  color: #fff;
  cursor: pointer;
}
.course {
  display: flex;
  /* min-width: 150px; */
  font-size: 18px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-18px);
}

.course a {
  width: 100px;
  height: 45px;
  color: #1872ED;
  text-align: center;
  line-height: 45px;
  transition: all 0.5s;
  border-radius: 25px;
}
.course .out-login {
  width: 100px;
  height: 45px;
  color: #1872ED;
  transition: all 0.5s;
  text-align: center;
  line-height: 45px;
  margin: 0 10px;
  cursor: pointer;
  border-radius: 25px;
}

.course a:hover {
  color: white;
  background-color: #1872ED;
}
.course .out-login:hover {
  color: white;
  background-color: #1872ED;
}
.course .head-sculpture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}
.course .head-sculpture img {
  width: 100%;
}
.head-sculpture {
  border-radius: 50%;
}
.before-login {
  float: right;
}
.content_box{
  height: 36px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.content_box img{
  margin-left: 15px;
  margin-right: 8px;
  height: 14px;
  width: 14px;
}
.content_box img:nth-child(2) {
  display: none;
}

.content_box:hover img:nth-child(1) {
  display: none;
}
.content_box:hover img:nth-child(2) {
  display: block;
}
.tolink{
  color: #202020;
  font-size: 14px;
}
.content_box:hover .tolink {
  color: #1872ED;
}
</style>
<style>
.popoverClass{
  padding: 0 !important;
  width: 100px !important;
  min-width: 110px !important;
  top:48px !important;
}
.popoverClass .popper__arrow{
    display: none !important; 
}
</style>
